import { useState, useEffect } from "react";
import { Button, Form, Input, Select, Spin } from "antd";
import { useNavigate } from "react-router";
import { connect } from "react-redux";

import { Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import Upload from "components/upload";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = ({ user }) => {
	const initialState = { cities: [], provinces: [] };
	const [state, setState] = useState(initialState);
	const { cities, loaded, provinces, submitting } = state;
	const navigate = useNavigate();

	const [form] = Form.useForm();
	const [passForm] = Form.useForm();

	const handleCity = (id) => {
		API.cities(id, { paginate: false })
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					loaded: true,
					cities: data?.map(({ id, name }) => ({ label: name, value: id })),
				}));
			})
			.catch({});
	};

	const handlePassword = () => {
		if (!submitting) {
			passForm.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				API.profile
					.updatePass(values)
					.then(() => {})
					.finally(() => {
						API.delCookie(process.env.REACT_APP_COOKIE_TOKEN);
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
						navigate("/auth/status");
					});
			});
		}
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values.avatarId = values.avatar?.id;
				delete values.avatar;

				values = ObjectNumbersToEnglish(values);

				API.profile
					.update(values)
					.then(() => {})
					.finally(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		API.provinces({ paginate: false })
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					provinces: data?.map(({ id, name }) => ({
						label: name,
						value: id,
					})),
				}));

				handleCity(user.province.id);

				form.setFieldsValue({
					...user,
					provinceId: user?.province?.id,
					cityId: user?.city?.id,
				});
			})
			.catch({});
	};

	useEffect(componentDidMount, []);

	return (
		<div className="panel-account">
			{loaded ? (
				<>
					<Form layout="vertical" form={form}>
						<div className="row">
							<div className="col-12">
								<div className="avatar"></div>
							</div>
							<div className="col-12">
								<Form.Item name="avatar" className="avatar">
									<Upload section={Types.upload.user} />
								</Form.Item>
							</div>
							<div className="col-12 col-md-6">
								<Form.Item name="firstName" label={Resources.firstName}>
									<Input size="large" />
								</Form.Item>
							</div>
							<div className="col-12 col-md-6">
								<Form.Item name="lastName" label={Resources.lastName}>
									<Input size="large" />
								</Form.Item>
							</div>
							<div className="col-12 col-md-6">
								<Form.Item name="provinceId" label={Resources.province}>
									<Select
										placeholder={Resources.province}
										options={provinces}
										optionFilterProp="label"
										onSelect={(id) => handleCity(id)}
										showSearch
										size="large"
									/>
								</Form.Item>
							</div>
							<div className="col-12 col-md-6">
								<Form.Item
									shouldUpdate={(prevValues, curValues) =>
										prevValues.provinceId !== curValues.provinceId
									}
									noStyle
								>
									{({ getFieldValue }) => {
										const provinceId = getFieldValue("provinceId");

										return (
											<Form.Item
												name="cityId"
												label={Resources.city}
												rules={Rules.required}
											>
												<Select
													options={cities}
													optionFilterProp="label"
													disabled={!provinceId}
													showSearch
													size="large"
												/>
											</Form.Item>
										);
									}}
								</Form.Item>
							</div>
							<div className="col-12">
								<Button
									type="primary"
									onClick={handleSubmit}
									loading={submitting}
								>
									{Resources.confirm}
								</Button>
							</div>
						</div>
					</Form>
					<hr className="hr-divider" />
					<Form layout="vertical" form={passForm}>
						<div className="row">
							<div className="col-12 col-md-6">
								<Form.Item
									name="oldPassword"
									label={`${Resources.password} ${Resources.previous}${Resources.y}`}
								>
									<Input size="large" type="password" />
								</Form.Item>
							</div>
							<div className="col-12 col-md-6">
								<Form.Item
									name="password"
									label={`${Resources.password} ${Resources.new}`}
								>
									<Input size="large" type="password" />
								</Form.Item>
							</div>
							<div className="col-12 col-md-6">
								<Form.Item
									name="passwordConfirmation"
									label={`${Resources.confirm} ${Resources.password} ${Resources.new}`}
								>
									<Input size="large" type="password" />
								</Form.Item>
							</div>
							<div className="col-12">
								<Button
									type="primary"
									onClick={handlePassword}
									loading={submitting}
								>
									{`${Resources.change} ${Resources.password}`}
								</Button>
							</div>
						</div>
					</Form>
				</>
			) : (
				<Spin className="page-loading" />
			)}
		</div>
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
